import SliderField from '@pages/Admin/CourseSettings/components/SliderField/SliderField'

type MonthlyPeriodSliderFieldProps = {
  value?: number | null
  onChange?: (value: number) => void
  min?: number
  max?: number
}

const MonthlyPeriodSliderField = ({
  value,
  onChange,
  min = 1,
  max = 24,
}: MonthlyPeriodSliderFieldProps) => {
  const normalizedValue = Math.max(min, Math.trunc(Number(value) || min))

  return (
    <SliderField
      label="Период"
      value={normalizedValue}
      extraContent={normalizedValue.toString()}
      min={min}
      max={max}
      onChange={(next) => onChange?.(next)}
    />
  )
}

export default MonthlyPeriodSliderField
